import FoundersNotesViewer from 'components/foundersNotes/FoundersNotesViewer';

const CanvasFoundersNotes = () => {
  return <FoundersNotesViewer embedded />;
};

export default CanvasFoundersNotes;
